export function setOpenDropdownItem(item) {
    return { type: 'SET_OPEN_ACTION_REACTION_DROPDOWN_ITEM', payload: item };
}

export function updateActionReactionSettings(settings) {
    return { type: 'UPDATE_ACTION_REACTION_SETTINGS', payload: settings };
}
